import { ActionIcon, AppShell, Box, Group, Image, Menu, rem, Title, useMantineTheme } from "@mantine/core";
import { IconUserCircle } from "@tabler/icons-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { customerQueryOptions } from "shared/graphql/customer";
import { useColorMode } from "shared/hooks/useColorMode";
import { useIsMobile } from "shared/hooks/useIsMobile";

export const logoMaxSize = 36;

const Component = () => {
    const {
        data: { customer },
    } = useSuspenseQuery(customerQueryOptions.whiteLabeling);

    const nav = useNavigate();
    const isMobile = useIsMobile();
    const theme = useMantineTheme();
    const { isDark } = useColorMode();

    return (
        <AppShell header={{ height: rem(60) }}>
            <AppShell.Header>
                <Group h="100%" px="md" justify="space-between" wrap="nowrap">
                    <Group pl="xs">
                        <Image
                            src={`${import.meta.env.VITE_API_BASE_URL}/customers/${customer.id}/icon`}
                            fallbackSrc={"/bryx.svg"}
                            style={{ maxWidth: logoMaxSize, maxHeight: logoMaxSize }}
                        />
                        <Title order={2} fw={"light"} lineClamp={1}>
                            {customer.name}
                        </Title>
                    </Group>
                    <Menu>
                        <Menu.Target>
                            <ActionIcon variant="filled" aria-label="Profile" radius="100%" size="lg">
                                <IconUserCircle size={20} stroke={1.5} />
                            </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                            <Menu.Item onClick={() => void nav({ to: "/logout" })}>Log out</Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                </Group>
            </AppShell.Header>
            <AppShell.Main
                style={{
                    height: isMobile ? "calc(100dvh - 116px)" : "92dvh",
                    maxHeight: isMobile ? "calc(100dvh - 116px)" : "92dvh",
                    background: isDark ? theme.colors.dark[6] : theme.colors.gray[2],
                }}
            >
                <Box w="100%" h="100%" style={{ overflowY: "auto" }}>
                    <Outlet />
                </Box>
            </AppShell.Main>
        </AppShell>
    );
};

/** @public */
export const Route = createFileRoute("/account")({
    component: Component,
});
